import React from 'react';
import { defineMessages, FormattedMessage } from '@kyruus/intl';
import { Link } from 'react-router-dom';
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';
import _extend from 'lodash/extend';
import _kebabCase from 'lodash/kebabCase';
import querystring from 'querystring';

import { getQueryModsToDeleteAvailParams } from './utils';
import { Suggestions } from './Suggestions';

const messages = defineMessages({
  browsebycommonspecialties: {
    id: 'noresults.browsebycommonspecialties',
    description: 'Header for suggestions of common searches',
    defaultMessage: 'Browse by Common Specialties'
  },
  noresults: {
    id: 'noresults.noresults',
    description: "The server didn't return any results for the search",
    defaultMessage: 'No results match your search.'
  },
  trymodifyingquery: {
    id: 'noresults.trymodifyingquery',
    description:
      'No results were returned for the search, so try removing some filters or searching for something else',
    defaultMessage:
      'Please try removing filters or begin a new search for condition, name, term, etc....'
  }
});

function TopSpecialtiesColumn({
  topSpecialties,
  getUpdatedSearch,
  log,
  history
}) {
  const specialtyList = _map(topSpecialties, (specialty) => {
    const logSpecialtySelected = () => {
      log('user_action.search_results.no_results_browse_clicked', {
        link: specialty.display_text,
        type: 'specialty'
      });
    };

    const modifications = [
      ...getQueryModsToDeleteAvailParams(
        querystring.parse(history.location.search.substring(1))
      )
    ];

    if (specialty.query_modifications) {
      modifications.push(...specialty.query_modifications);
    }

    const updatedSearch = getUpdatedSearch(modifications);

    return (
      <div className="pb-s no-wrap" key={specialty.display_text}>
        <Link
          to={updatedSearch}
          id={`top-specialty-${_kebabCase(specialty.display_text)}`}
          className="top-specialty"
          onClick={logSpecialtySelected}
        >
          <h3>{specialty.display_text}</h3>
        </Link>
      </div>
    );
  });
  return <div className="col-sm-6 col-xs-12">{specialtyList}</div>;
}

function TopSpecialties({ topSpecialties, getUpdatedSearch, log, history }) {
  if (_isEmpty(topSpecialties)) {
    return null;
  } else {
    const splitIndex = topSpecialties.length / 2;
    const col1 = topSpecialties.slice(0, splitIndex);
    const col2 = topSpecialties.slice(splitIndex);
    const logTopSpecialties = (message, event_data = {}) =>
      log(
        message,
        _extend(
          { all_links: { specialties: _map(topSpecialties, 'display_text') } },
          event_data
        )
      );
    return (
      <div
        id="top-specialties"
        className="top-specialties pa-m mb-m bc-soft"
        data-testid="noResults.topSpecialties"
      >
        <h3 className="pb-s">
          <FormattedMessage {...messages.browsebycommonspecialties} />
        </h3>
        <div className="row">
          <TopSpecialtiesColumn
            topSpecialties={col1}
            getUpdatedSearch={getUpdatedSearch}
            log={logTopSpecialties}
            history={history}
          />
          <TopSpecialtiesColumn
            topSpecialties={col2}
            getUpdatedSearch={getUpdatedSearch}
            log={logTopSpecialties}
            history={history}
          />
        </div>
      </div>
    );
  }
}

function NoResults({
  suggestions,
  topSpecialties,
  getUpdatedSearch,
  log,
  history,
  config
}) {
  return (
    <div>
      <div className="no-results ma-xl">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <h2 className="mb-s">
                <FormattedMessage {...messages.noresults} />
              </h2>
              <h4 className="mb-l">
                <FormattedMessage {...messages.trymodifyingquery} />
              </h4>
              {config.KENG_38276_show_search_suggestions_v9 &&
              suggestions &&
              suggestions.length > 0 ? (
                <Suggestions
                  getUpdatedSearch={getUpdatedSearch}
                  log={log}
                  suggestions={suggestions}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {topSpecialties && topSpecialties.length > 0 ? (
        <TopSpecialties
          topSpecialties={topSpecialties}
          getUpdatedSearch={getUpdatedSearch}
          log={log}
          history={history}
        />
      ) : null}
    </div>
  );
}

export { NoResults, TopSpecialties };
export default NoResults;
